import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../react-query/constants";
import { getLoginToken } from "../storage";

async function getCaveat() {
  const data = await axiosInstance({
    url: "/caveat",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const createCaveat = async (formData: any) => {
  const data = await axiosInstance({
    url: "/caveat",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateCaveat = async (formData: any) => {
  const data = await axiosInstance({
    url: `/caveat/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteCaveat = async (formData: any) => {
  const data = await axiosInstance({
    url: `/caveat/${formData}?hard=true`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useCaveat() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.caveat],
    queryFn: () => getCaveat(),
  });
  return data;
}

export function useCreateCaveat() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createCaveat(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.caveat]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateCaveat() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateCaveat(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.caveat]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteCaveat() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteCaveat(formData),
    onSuccess: (data) => {
      //   toast.success("Caveat Deleted Successfully", toastOptions);
      queryClient.invalidateQueries([queryKeys.caveat]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
